export default __webpack_public_path__ + "static/media/kg.ba2007bf.svg";